<div class="fdk-select">
  <label
    class="fdk-select__label"
    [for]="selectId">
    {{ label }}
    @if (required) {
      <span
        class="fdk-select__required"
        aria-hidden="true">*</span>
    }
  </label>

  <div class="fdk-select__control-wrapper">
    <select
      class="fdk-select__control"
      (blur)="handleBlur()"
      (change)="handleChange($event)"
      [class.fdk-select__control--error]="error"
      [attr.aria-describedby]="describedBy"
      [attr.aria-invalid]="error ? 'true' : null"
      [disabled]="disabled"
      [id]="selectId"
      [attr.name]="name"
      [required]="required"
      [value]="value">
      @if (placeholder) {
        <option
          disabled
          value="">
          {{ placeholder }}
        </option>
      }
      @for (option of options; track $index) {
        <option
          [disabled]="optionDisabled(option)"
          [value]="optionValue(option)">
          {{ optionLabel(option) }}
        </option>
      }
    </select>

    <fdk-icon
      class="fdk-select__arrow"
      name="chevron-down"
      [size]="24" />
  </div>

  @if (showErrorMessage) {
    <p
      class="fdk-select__error"
      [id]="errorMessageId">
      {{ errorMessage }}
    </p>
  }
</div>
